var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWeb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "web",
    transform: "translate(-904 -492)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_278",
    "data-name": "Rectangle 278",
    width: 18,
    height: 18,
    transform: "translate(904 492)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-globe",
    "data-name": "Icon feather-globe",
    transform: "translate(902 490)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M18.024,10.512A7.512,7.512,0,1,1,10.512,3,7.512,7.512,0,0,1,18.024,10.512Z",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M3,18H18.024",
    transform: "translate(0 -7.488)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M15,3a11.494,11.494,0,0,1,3,7.512,11.494,11.494,0,0,1-3,7.512,11.494,11.494,0,0,1-3-7.512A11.494,11.494,0,0,1,15,3Z",
    transform: "translate(-4.493)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeb);
export default __webpack_public_path__ + "static/media/web.10ab2cbbb44d0e8872e12608d7885f5c.svg";
export { ForwardRef as ReactComponent };